<!--
  The one nudge used wherever the right panel shows a feature that needs a Nanome workspace (Ligands sketch, MARA
  free-form replies and input tools, Import from Chat, Users). The button opens the Open in Nanome dialog through
  the function WorkspacePanelRight provides.
-->
<script setup lang="ts">
import NanomeIcon from '@/components/NanomeIcon.vue';
import { inject } from 'vue';
import Button from 'primevue/button';
import { OPEN_IN_NANOME } from './open-in-nanome-key';

withDefaults(defineProps<{ title: string; text?: string; card?: boolean }>(), { text: '', card: false });
const open = inject(OPEN_IN_NANOME, () => {});
</script>

<template>
  <div
    :class="card ? 'p-5 bg-content rd-4 shadow-lg b-1 b-solid b-section' : ''"
    class="teaser-cta max-w-20rem flex flex-col items-center gap-3 text-center"
    data-test="teaser-cta"
  >
    <div class="flex flex-col gap-1">
      <div class="font-medium">
        {{ title }}
      </div>
      <div v-if="text" class="text-sm op-60">
        {{ text }}
      </div>
    </div>
    <Button
      label="Open in Nanome"
      size="small"
      rounded
      data-test="teaser-open"
      @click="open()"><template #icon="iconProps"><NanomeIcon :class="iconProps.class" /></template></Button>
  </div>
</template>
